module.exports = __webpack_public_path__ + "ff3dcdd1b11c2e188c9e7165268b1277.svg";